const getAwsSettings = (cognitoConfig)=>{
    const auth = {
        userPoolId: cognitoConfig.userPoolId,
        userPoolWebClientId: cognitoConfig.userPoolWebClientId,
        signUpVerificationMethod: cognitoConfig.signUpVerificationMethod || 'link',
        oauth: {
            domain: cognitoConfig.oauth.domain,
            scope: cognitoConfig.oauth.scope ?? [
                'phone',
                'email',
                'profile',
                'openid'
            ],
            redirectSignIn: cognitoConfig.oauth.redirectSignIn,
            redirectSignOut: cognitoConfig.oauth.redirectSignOut
        }
    };
    if (cognitoConfig.cookieStorage) return {
        Auth: {
            ...auth,
            cookieStorage: {
                domain: cognitoConfig.cookieStorage.domain
            }
        }
    };
    return {
        Auth: auth
    };
};
export { getAwsSettings };
